var map = {
	"./About/carousel/图1.png": "3958",
	"./About/carousel/图2.png": "6dc8",
	"./About/carousel/图3.png": "1c3f",
	"./About/carousel/图4.png": "8d62",
	"./About/company_caseeight.svg": "4517",
	"./About/company_caseelven.png": "1a8d",
	"./About/company_casefive.svg": "818a",
	"./About/company_casefour.svg": "6ae6",
	"./About/company_casenine.png": "b305",
	"./About/company_caseone.svg": "4b83",
	"./About/company_caseseven.svg": "b59b",
	"./About/company_casesix.svg": "725a",
	"./About/company_caseten.svg": "48f7",
	"./About/company_casethree.svg": "e0c1",
	"./About/company_casetwelve.png": "c295",
	"./About/company_casetwo.svg": "3f57",
	"./About/company_cerfive.png": "de33",
	"./About/company_cerfour.png": "3e49",
	"./About/company_cerone.png": "4567",
	"./About/company_certhree.png": "06a7",
	"./About/company_certwo.png": "8749",
	"./About/company_eighteen.svg": "da16",
	"./About/company_fifteen.png": "28a9",
	"./About/company_fourteen.png": "97b4",
	"./About/company_header.png": "7bca",
	"./About/company_nineteen.png": "a27f",
	"./About/company_pic.png": "ac7a",
	"./About/company_seventeen.svg": "3566",
	"./About/company_sixteen.svg": "97f6",
	"./About/company_tag.svg": "8e3a",
	"./About/company_thirteen.svg": "1d75",
	"./About/官网-证书-云指课堂教学资源系统.png": "cced",
	"./About/官网-证书-信息化平台ios.png": "7e51",
	"./About/官网-证书-出版.png": "fba2",
	"./About/官网-证书-国贸安卓APP.png": "31f5",
	"./About/官网-证书-实训.png": "9e04",
	"./About/官网-证书-投屏.png": "9e61",
	"./About/官网-证书-然也信息化教学平台.png": "c2da",
	"./About/官网-证书-资源库建设平台.png": "a183",
	"./About/官网-证书-资源建设系统.png": "9629",
	"./CarouselSchool/home_eight.png": "3042",
	"./CarouselSchool/home_eighteen.png": "f812",
	"./CarouselSchool/home_eleven.png": "6645",
	"./CarouselSchool/home_fifteen.png": "f689",
	"./CarouselSchool/home_five.png": "67ef",
	"./CarouselSchool/home_four.png": "8135",
	"./CarouselSchool/home_fourteen.png": "0bf7",
	"./CarouselSchool/home_nine.png": "f66e",
	"./CarouselSchool/home_nineteen.png": "e10d",
	"./CarouselSchool/home_one.png": "93bf",
	"./CarouselSchool/home_seven.png": "b19e",
	"./CarouselSchool/home_seventeen.png": "6888",
	"./CarouselSchool/home_six.png": "76db",
	"./CarouselSchool/home_sixteen.png": "89d4",
	"./CarouselSchool/home_ten.png": "6c8a",
	"./CarouselSchool/home_thirteen.png": "0e85",
	"./CarouselSchool/home_three.png": "eb3c",
	"./CarouselSchool/home_twelve.png": "d915",
	"./CarouselSchool/home_two.png": "f778",
	"./Courses/BasicAccounting_1.jpg": "87ff",
	"./Courses/BasicAccounting_2.jpg": "d64f",
	"./Courses/CrossBorderExportEcommerceJourney_1.jpg": "28af",
	"./Courses/CrossBorderExportEcommerceJourney_2.jpg": "f785",
	"./Courses/InternationalFreightForwarderPractice_1.jpg": "c68c",
	"./Courses/InternationalFreightForwarderPractice_2.jpg": "2db2",
	"./Courses/InternationalTradePractice_1.jpg": "e879",
	"./Courses/MakingForeignTradeDocuments_1.jpg": "1e71",
	"./Courses/MakingForeignTradeDocuments_2.jpg": "83cc",
	"./Platform-Icon/Dialog-Images/bg_作业试卷.png": "5663",
	"./Platform-Icon/Dialog-Images/bg_学生学习.png": "ecf6",
	"./Platform-Icon/Dialog-Images/bg_教学互动.png": "53e0",
	"./Platform-Icon/Dialog-Images/bg_教学备课.png": "909f",
	"./Platform-Icon/Dialog-Images/bg_数据中心.png": "3ce7",
	"./Platform-Icon/Dialog-Images/bg_考核评价.png": "b599",
	"./Platform-Icon/Dialog-Images/bg_行企动态.png": "09a8",
	"./Platform-Icon/Dialog-Images/bg_课堂实训.png": "9164",
	"./Platform-Icon/Dialog-Images/bg_课堂教学.png": "3811",
	"./Platform-Icon/Dialog-Images/bg_课程建设.png": "e19d",
	"./Platform-Icon/Dialog-Images/ic_close.svg": "1bf2",
	"./Platform-Icon/作业试卷.svg": "8ae6",
	"./Platform-Icon/学生学习.svg": "43f9",
	"./Platform-Icon/教学互动.svg": "3f67",
	"./Platform-Icon/教学备课.svg": "b1f0",
	"./Platform-Icon/数据中心.svg": "e328",
	"./Platform-Icon/考核评价.svg": "18c4",
	"./Platform-Icon/行企动态.svg": "df53",
	"./Platform-Icon/课堂实训.svg": "18ac",
	"./Platform-Icon/课堂建设.svg": "30f6",
	"./Platform-Icon/课堂教学.svg": "bed4",
	"./QualityPlatform/qualityPlatform_tag.png": "8eae",
	"./QualityPlatform/qualityPlatform_数据全面丰富.png": "3fcd",
	"./QualityPlatform/qualityPlatform_数据反馈过程.png": "0caa",
	"./QualityPlatform/qualityPlatform_数据时效性强.png": "ec1d",
	"./QualityPlatform/qualityPlatform_数据来源真实.png": "5116",
	"./Solutions/solution_courseMindMap.png": "6e8a",
	"./Solutions/solution_header.png": "4a47",
	"./Solutions/solution_platformMindMap.png": "f983",
	"./home_android.svg": "6ea3",
	"./home_arrow.svg": "162d",
	"./home_banner.png": "222a",
	"./home_barcode.png": "42ac",
	"./home_computer.png": "6467",
	"./home_contact.svg": "7175",
	"./home_down.png": "6f3e",
	"./home_downloadBarcode.png": "6a47",
	"./home_ios.svg": "be86",
	"./home_logo.png": "5fcc",
	"./home_schoolfour.svg": "08ae",
	"./home_schoolone.svg": "33e3",
	"./home_schoolthree.svg": "b460",
	"./home_schooltwo.svg": "64cb",
	"./home_slogan.svg": "2cc3",
	"./home_tag(1).svg": "35a6",
	"./home_tag.svg": "efa6",
	"./home_top.png": "d8f9",
	"./ic_bluepeople copy 2.svg": "9f41",
	"./ic_bluepeople copy.svg": "9438",
	"./ic_bluepeople.svg": "022d",
	"./ic_email.svg": "aa6e",
	"./ic_govRecord.png": "ea9d",
	"./ic_phone.svg": "0e09",
	"./mobile/mobile_home_app_logo.png": "75ee",
	"./mobile/mobile_home_cover_background.png": "5a12",
	"./mobile/mobile_home_download_banner_background.png": "786f",
	"./mobile/mobile_home_download_banner_close.png": "c760",
	"./mobile/mobile_home_slogan.png": "cc0f",
	"./p&s-course1.jpg": "db44",
	"./p&s-course2.jpg": "4812",
	"./p&s-course3.jpg": "4be2",
	"./p&s-course4.jpg": "1672",
	"./p&s-course5.jpg": "7321",
	"./p&s-plat1.jpg": "36a9",
	"./p&s-plat2.jpg": "3086",
	"./p&s-plat3.jpg": "8b45",
	"./p&s-plat4.jpg": "0c37",
	"./云指课堂logo.png": "47a9",
	"./平台建设方案.svg": "eaec",
	"./课程建设方案.svg": "b5de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";